<template>
  <AppHeader>Send Notification</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Group</p>
        <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.group_id" name="group_id" required>
          <option value="0">All Groups</option>
          <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.group_id">{{ errors.group_id }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Type</p>
        <select class="w-full text-xl bg-white placeholder:text-lg" @change="updateNotificationContent" v-model="form.type" name="type" required>
          <option value="">-- Select Type --</option>
          <option value="recharge">Wallet Recharge Reminder</option>
          <option value="emptybottle">Empty Bottle Reminder</option>
          <option value="rain">Heavy rain</option>
          <option value="repair">Vehicle repair</option>
          <option value="absent">Delivery boy absent</option>
          <option value="delay">General Delay</option>
          <option value="deliverycancelled">Delivery Canceled</option>
          <option value="cannotdeliverrain">Unable to Deliver - Rain</option>
          <option value="cannotdeliver">Unable to Deliver</option>
          <option value="newdeliveryboy">New Delivery Boy</option>
          <option value="eveningdelivery">Evening Delivery</option>
          <option disabled value="">----</option>
          <option value="custom">Custom</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.type">{{ errors.type }}</p>
      </div>

      <div v-if="form.type == 'custom'" class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Title</p>
        <input class="w-full text-xl placeholder:text-lg" v-model="form.title" name="title" placeholder="Notification Title">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.title">{{ errors.title }}</p>
      </div>

      <div v-if="form.type == 'custom'" class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Message</p>
        <textarea class="w-full text-xl placeholder:text-lg" v-model="form.msg" name="msg" placeholder="Notification Message"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.msg">{{ errors.msg }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="createNotification">Create Notification</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'CreateNotification',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      groups: [],
      notifications : {
        recharge: { title : 'Recharge your Uzhavarbumi Wallet', msg: 'Dear Customer, please check your UB Wallet, if low Recharge today. Deliveries will be cancelled if balance low.', linkType: 'internal', link: '/wallet' },
        emptybottle: { title : 'A Reminder for Empty Milk Bottles', msg: 'Dear Customer, we wish to remind you to rinse & return Empty Milk Bottles, everyday without fail. Please ignore the message if you have already returned the bottles' },
        rain: { title : 'Your Milk Delivery is Delayed', msg: 'Dear Customer, due to heavy rain, your delivery will be delayed today', linkType: 'action', link: 'WhatsappDealer' },
        repair: { title : 'Your Milk Delivery is Delayed', msg: 'Dear Customer, due to vehicle repair, your delivery will be delayed today', linkType: 'action', link: 'WhatsappDealer' },
        absent: { title : 'Your Milk Delivery is Delayed', msg: 'Dear Customer, our delivery boy is absent, your delivery will be delayed today', linkType: 'action', link: 'WhatsappDealer' },
        delay: { title : 'Your Milk Delivery is Delayed', msg: 'Dear Customer, your delivery will be delayed today', linkType: 'action', link: 'WhatsappDealer' },
        deliverycancelled: { title : 'Your Milk Delivery is Canceled', msg: 'Dear Customer, all deliveries have been canceled for today. Please contact your Dealer', linkType: 'action', link: 'CallDealer' },
        cannotdeliver: { title : 'Your Milk Delivery is Canceled', msg: 'Dear Customer, we are unable to deliver today. Please contact your Dealer', linkType: 'action', link: 'CallDealer' },
        newdeliveryboy: { title : 'New Delivery Boy Assigned', msg: 'Dear Customer, we have assigned a new delivery rider for you.', linkType: 'action', link: 'WhatsappDealer' },
        eveningdelivery: { title : 'Your Milk will be Delivered in the Evening', msg: 'Dear Customer, due to a delay in delivery, we will make your Milk delivery in the evening', linkType: 'action', link: 'CallDealer' },
        custom: { title : '', msg: '', link: null, linkType: null },
      },
      form: { type: '', group_id: 0, title: null, msg: null },
    };
  },

  methods: {
    updateNotificationContent() {
      this.form.title = this.notifications[this.form.type].title;
      this.form.msg = this.notifications[this.form.type].msg;
      this.form.linkType = this.notifications[this.form.type].linkType;
      this.form.link = this.notifications[this.form.type].link;
    },

    getData() {
      this.state = 'loading';

      this.request('GET', 'notifications/prepare', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.groups = resp.data.groups;
      });
    },

    createNotification() {
      let rules = {
        group_id: 'required',
        type: 'required',
        title: 'required',
        msg: 'required',
      };

      if (!this.validateForm(this.form, rules)) return;
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';

      this.request('POST', 'notifications', this.form, (resp) => {
        this.state = 'idle';
        alert(resp.message);
        if (resp.success) this.form = { type: '', group_id: 0 };
      });
    },
  },

  created() {
    if (!this.$store.state.user.id) this.$router.push('/dash');
    else this.getData();
  }
}
</script>
